import ApiDrivenModel from "../../../../models/ApiDrivenModel";

export default class SaleReportComment extends ApiDrivenModel {
	static ENDPOINT = "/Sale_Report_Comment";
}
